import { gql } from '@apollo/client'

export const EXPORT_WATER_SCARCITY_QUERY = gql`
  query WaterScarcity(
    $first: Int
    $after: String
    $where: WaterScarcityGraphQlFilterInput
    $order: [WaterScarcityGraphQlSortInput!]
  ) {
    waterScarcity(first: $first, after: $after, where: $where, order: $order) {
      nodes {
        id
        cfAwareAgri
        cfAwareNonNullAgri
        countryName
        isoAlpha2
        isoAlpha3
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`
